import MoreVert from '@app/components/Icons/MoreVert';
import ShimmerImage from '@app/components/ShimmerImage';
import { URL_SMALL_LOGO } from '@app/config/urls';
import { CircularProgress } from '@material-ui/core';
import { RestaurantMenu } from '@material-ui/icons';
import FooterLabel from './FooterLabel';
import {
  Container,
  Footer,
  InformationBox,
  ListaZapLink,
  LogoBox,
  InformationInfo,
  NameDescription,
  TitleBox,
  Title,
  LogoBoxInternal,
} from './styles';

export const FooterIcons = {
  OrderInTableOrCounter: <RestaurantMenu style={{ color: '#41c64e' }} />,
  OnlyOnOrder: <img src="/static/encomenda.png" alt="Apenas sob encomenda" style={{ height: 20 }} />,
  LocalPickUp: <img src="/static/takeOut.svg" alt="Retirada no local" style={{ height: 17 }} />,
  Delivery: <img src="/static/deliveryIcon.svg" alt="Estabelecimento entregando no momento" />,
};

export type RestaurantInfoBaseProps = {
  logoURL: string | null;
  name: string;
  nameWithActivity: string;
  cityLabel: string;
  listaZapLink: string;
  categoryName: string;
  isAInternalMenuOrOrderedOnRestaurant: boolean;
  isAInternalMenu: boolean;
  isOrderedOnRestaurant: boolean;
  timeManagerIsReady: boolean;
  isOpen: boolean;
  primaryColor: string;
  onlyOnOrder: boolean;
  delivering: boolean;
  ableDelivery: boolean;
  localPickup: boolean;
  tableNumber: number | undefined;
  counterNumber: number | undefined;
  isLoggedInClientArea: boolean;
};

export default function RestaurantInfoBase(props: RestaurantInfoBaseProps) {
  const {
    logoURL,
    name,
    nameWithActivity,
    cityLabel,
    localPickup,
    isAInternalMenuOrOrderedOnRestaurant,
    listaZapLink,
    categoryName,
    ableDelivery,
    counterNumber,
    tableNumber,
    timeManagerIsReady,
    delivering,
    isAInternalMenu,
    isOpen,
    isOrderedOnRestaurant,
    onlyOnOrder,
    primaryColor,
    isLoggedInClientArea,
  } = props;

  const orderInTheTable = !!tableNumber;

  function renderFooterContent() {
    if (isAInternalMenu) {
      if (isOrderedOnRestaurant) return renderTableOrCounterNumber();
      return null;
    }

    if (isOrderedOnRestaurant) return renderTableOrCounterNumber();

    if (!timeManagerIsReady) return <CircularProgress style={{ color: primaryColor }} size={18} />;

    if (!isOpen) return <FooterLabel text="Fechado" color="#ef4249" />;

    const localPickupText = delivering && ableDelivery ? 'Retirada no Local' : 'Apenas retirada no local';
    if (onlyOnOrder) {
      return (
        <>
          <FooterLabel icon={FooterIcons.OnlyOnOrder} text="Apenas sob encomenda" color="#8d6e63" />
          <FooterLabel icon={FooterIcons.LocalPickUp} text={localPickupText} color="#d9480f" />
        </>
      );
    }

    return (
      <>
        {ableDelivery && (
          <FooterLabel
            icon={FooterIcons.Delivery}
            text={delivering ? 'Entregando' : 'Não entrega agora'}
            color="#25d366"
          />
        )}

        {localPickup && <FooterLabel icon={FooterIcons.LocalPickUp} text={localPickupText} color="#d9480f" />}
      </>
    );

    function renderTableOrCounterNumber() {
      const text = orderInTheTable ? `Mesa ${tableNumber}` : `Balcão ${counterNumber}`;
      return <FooterLabel icon={FooterIcons.OrderInTableOrCounter} text={text} color="#41c64e" />;
    }
  }

  const shouldDisplayCategoryAndCity = Boolean(!isAInternalMenuOrOrderedOnRestaurant && !isLoggedInClientArea);
  const shouldDisplayActivity = Boolean(!isAInternalMenuOrOrderedOnRestaurant && !isLoggedInClientArea);
  const shouldDisplayFooter = Boolean(!isLoggedInClientArea);

  return (
    <Container>
      {logoURL && (
        <LogoBox>
          <ShimmerImage
            src={URL_SMALL_LOGO + logoURL}
            alt={name}
            layout="intrinsic"
            width={100}
            height={100}
            objectFit="contain"
            shimmer={{ borderRadius: '50%' }}
          />
        </LogoBox>
      )}

      <InformationBox>
        <InformationInfo>
          {logoURL && (
            <LogoBoxInternal>
              <ShimmerImage
                src={URL_SMALL_LOGO + logoURL}
                alt={name}
                layout="intrinsic"
                width={70}
                height={70}
                objectFit="contain"
                shimmer={{ borderRadius: '50%' }}
              />
            </LogoBoxInternal>
          )}

          <NameDescription>
            <TitleBox>
              <Title>{shouldDisplayActivity ? nameWithActivity : name}</Title>
              <ListaZapLink href={listaZapLink}>
                <MoreVert color="#999" />
              </ListaZapLink>
            </TitleBox>
            {shouldDisplayCategoryAndCity && (
              <h2>
                {categoryName}
                {cityLabel}
              </h2>
            )}
          </NameDescription>
        </InformationInfo>

        {shouldDisplayFooter && <Footer>{renderFooterContent()}</Footer>}
      </InformationBox>
    </Container>
  );
}
